/**
 * Remix video's chooser (Dax, 2026-10-01): one button per platform in REMIX_PRESETS, each with its line,
 * the choice making the edit. Long-form YouTube is offered only for wide footage.
 */
import { REMIX_PRESETS, RemixTarget } from '@studio/contracts';

export function RemixModal({ wide, pending, error, onPick, onClose }: {
  wide: boolean;
  pending: boolean;
  error: string | null;
  onPick: (target: RemixTarget) => void;
  onClose: () => void;
}) {
  return (
    <>
      <button type="button" className="overlay overlay-btn" aria-label="Close" onClick={onClose} />
      <div className="modal remix-modal" role="dialog" aria-label="Remix video">
        <h2>Remix video</h2>
        <div className="remix-options">
          {RemixTarget.options.map((target) => {
            const preset = REMIX_PRESETS[target];
            const unavailable = preset.wideOnly && !wide;
            return (
              <button key={target} type="button" className="remix-option" disabled={pending || unavailable} onClick={() => onPick(target)}>
                <b>{preset.label}</b>
                <span className="sub">{unavailable ? 'Wide footage only' : preset.summary}</span>
              </button>
            );
          })}
        </div>
        {error && <div className="error" role="alert">{error}</div>}
        <div className="row between">
          <span className="sub">{pending ? 'Remixing…' : ''}</span>
          <button type="button" className="btn quiet" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </>
  );
}
